export default function getJson(url: string): Promise<any> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url);
    xhr.onerror = reject;
    xhr.onload = () => {
      resolve(JSON.parse(xhr.responseText));
    };
    xhr.send();
  });
}